export const makeSvg = (hairBase64, eyesBase64, bodyBase64, outlineBase64, width, height) => {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}">
        <defs>
            ${hairBase64 ? `<mask id="mh" mask-type="alpha">
        <image width="${width}" height="${height}" href="${hairBase64}"/>
    </mask>` : ""
    }
            
             ${eyesBase64 ? `<mask id="me" mask-type="alpha">
        <image width="${width}" height="${height}" href="${eyesBase64}"/>
    </mask>` : ""
    }
            
             ${bodyBase64 ? `<mask id="mb" mask-type="alpha">
        <image width="${width}" height="${height}" href="${bodyBase64}"/>
    </mask>` : ""
    }
        </defs>
        
        ${bodyBase64 ? `<g mask="url(#mb)">
            <rect x="0" y="0" width="${width}" height="${height}" fill="#00FF00"/>
        </g>` : ""}
        
         ${eyesBase64 ? `<g mask="url(#me)">
            <rect x="0" y="0" width="${width}" height="${height}" fill="#FFFF00"/>
        </g>` : ""}
        
         ${hairBase64 ? `<g mask="url(#mh)">
            <rect x="0" y="0" width="${width}" height="${height}" fill="#0000FF"/>
        </g>` : ""}
        
        ${outlineBase64 ? `<image width="${width}" height="${height}" href="${outlineBase64}" />` : ""}
    </svg>`;
}